import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Text, Button, Icon, Img, BadgeStatut } from '../../Atoms';
import {
  getRemboursementStatut,
  BADGE_LABEL_BY_STATUT,
  REMBOURSEMENT_STATUT
} from '../../Utils/remboursementMessage';
import { Modal, ChartLegendMolecule } from '../../Molecules';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Chart from 'react-apexcharts';
import { ModalConfirmRating, ModalRating } from '../../Modals';
import * as moment from 'moment';
import styles from './TemplateHome.module.scss';
import ShortcutButton from './components/ShortcutButton';

import NewHomeCarteTpImage from '../../assets/img/newhome-cartetp.png';
import NewHomeAskRemboursementImage from '../../assets/img/newhome-ask-remboursement.png';
import NewHomeGarantiesImage from '../../assets/img/newhome-garanties.png';
import NewHomeMedadomImage from '../../assets/img/newhome-medadom.png';
import NewHomeSendDocumentImage from '../../assets/img/newhome-send-document.png';
import cgrmIntroModalImg from '../../assets/img/cgrm-intro-modal.png';
import NewHomeTeleconsultationImage from '../../assets/img/newhome-teleconsultation.png';
import {SoinsDateActe} from "../../Atoms/SoinsDateActe";

function TemplateHome(props) {
  const user = useSelector((state) => state.auth.user);
  // const [show, setShow] = useState(user.hasIntro);
  const twoYearsAgo = moment().subtract(2, 'year');
  const twoYearsAgoDate = new Date(twoYearsAgo);
  const [show, setShow] = useState(false);
  const [step, setStep] = useState(1);
  const dispatch = useDispatch();
  const tuto = useSelector((state) => state.tuto);
  const sideBar = useSelector((state) => state.sideBar);
  const rating = useSelector((state) => state.rating);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const mediaQuery = window.matchMedia('(max-width: 768px)');
  console.log('initializing Home template');
  console.log(props);
  const shortcutCarouselRef = useRef(null);
  const [carouselPage, setCarouselPage] = useState(0);
  const [cgrmModalShow, setCgrmModalShow] = useState(
    props?.currentUser?.memberType == 'Affiliate' &&
      localStorage.getItem('showCgrmModal') === 'true'
  );

  const handleScroll = useCallback(
    (e) => {
      const el = shortcutCarouselRef.current;
      const currentScroll = el.scrollLeft;
      const totalWidth = el.scrollWidth - el.offsetWidth;
      const itemSize = 190 + 40;
      const page = Math.round(currentScroll / itemSize);
      console.log(
        'state: ' + carouselPage,
        'computed: ' + page,
        carouselPage !== page
      );
      if (parseInt(carouselPage) !== parseInt(page)) {
        setCarouselPage(page);
      }

      if (currentScroll === totalWidth) {
        setCarouselPage(SHORTCUTS_ELEMENTS.length - 1);
      }
    },
    [carouselPage]
  );

  const SHORTCUTS_ELEMENTS = [
    {
      text: 'Ma carte de tiers payant',
      img: NewHomeCarteTpImage,
      onClick: () => {
        props.history.push('/cartetp');
      },
      optClass: 'short-text-container'
    },
    {
      text: 'Demander un remboursement',
      img: NewHomeAskRemboursementImage,
      onClick: props.sendBill
    },
    {
      text: 'Envoi de documents',
      img: NewHomeSendDocumentImage,
      onClick: () => {
        props.history.push('/documents/send');
      },
      optClass: 'short-text-container'
    },
    {
      text: 'Visualiser mes garanties',
      img: NewHomeGarantiesImage,
      onClick: () => {
        props.history.push('/garanties');
      }
    }
  ];

  const getOptionChart = (color) => {
    return {
      tooltip: {
        enabled: false
      },
      stroke: {
        colors: ['undefined']
      },
      chart: {
        id: 'home',
        width: 300,
        height: 300,
        type: 'donut',
        redrawOnWindowResize: true,
        dropShadow: {
          enabled: false
        },
        events: {
          click: undefined
        }
      },
      legend: {
        show: false
      },
      colors: color,
      dataLabels: {
        formatter: function (val, num, opts) {
          return num.w.globals.series[num.seriesIndex] + ' €';
        },
        distributed: true,
        textAnchor: 'end',
        style: {
          fontSize: '11px',
          fontFamily: 'Raleway',
          fontWeight: 700,
          colors: ['#000']
        },
        dropShadow: {
          enabled: false
        }
      },
      plotOptions: {
        pie: {
          startAngle: 0,
          endAngle: 360,
          expandOnClick: false,
          dataLabels: {
            offset: 35,
            minAngleToShowLabel: 0
          },
          donut: {
            background: 'transparent',
            labels: {
              show: true,
              name: {
                show: false
              },
              value: {
                fontSize: '14px',
                fontFamily: 'Raleway',
                fontWeight: 800,
                color: '#000'
              },
              total: {
                show: true,
                fontSize: '17px',
                fontFamily: 'Raleway',
                fontWeight: 800,
                color: '#000',
                formatter: function (w) {
                  const total = w.globals.seriesTotals.reduce((a, b) => {
                    return a + b;
                  }, 0);
                  return total.toFixed(2) + ' €';
                }
              }
            }
          }
        }
      }
      // responsive: [
      //   {
      //     breakpoint: 768,
      //     options: {
      //       chart: {
      //         type: 'donut',
      //         width: '100%',
      //         height: '100%'
      //       },
      //       dataLabels: {
      //         style: {
      //           fontSize: '9px',
      //           fontFamily: 'Raleway',
      //           fontWeight: 'bold',
      //           colors: ['#000']
      //         }
      //       },
      //       plotOptions: {
      //         pie: {
      //           expandOnClick: false,
      //           dataLabels: {
      //             offset: 30,
      //             minAngleToShowLabel: 0
      //           },
      //           donut: {
      //             background: 'transparent',
      //             labels: {
      //               show: true,
      //               name: {
      //                 show: false
      //               },
      //               value: {
      //                 fontSize: '14px',
      //                 fontFamily: 'Raleway',
      //                 fontWeight: 800,
      //                 color: '#000'
      //               },
      //               total: {
      //                 show: true,
      //                 fontSize: '13px',
      //                 fontFamily: 'Raleway',
      //                 fontWeight: 800,
      //                 color: '#000',
      //                 formatter: function (w) {
      //                   const total = w.globals.seriesTotals.reduce((a, b) => {
      //                     return a + b;
      //                   }, 0);
      //                   return total.toFixed(2) + ' €';
      //                 }
      //               }
      //             }
      //           }
      //         }
      //       }
      //     }
      //   }
      // ]
    };
  };
  useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowHeight(window.innerHeight);
      setWindowWidth(window.innerWidth);
    });
  }, []);
  useEffect(() => {
    if (window.innerWidth < 762) {
      if (step == 9) {
        dispatch({ type: 'SET_CURRENT_SIDE_BAR', value: { open: true } });
      } else {
        if (sideBar.open == true) {
          dispatch({ type: 'SET_CURRENT_SIDE_BAR', value: { open: false } });
        }
      }
    }
    if (step == 7 || step == 8 || (step == 9 && window.innerWidth > 762)) {
      dispatch({ type: 'SET_STEP', value: { step: step } });
    } else {
      if (tuto.step != null) {
        dispatch({ type: 'SET_STEP', value: { step: null } });
      }
    }
  }, [step]);
  function renderClassNameTuto(mobileStep, webStep = 0) {
    let className = '';
    if (window.innerWidth < 762) {
      if (mobileStep == step) {
        if (step == 9) {
          className = ' text-tuto-full-opacity';
        } else {
          className = ' tuto-full-opacity';
        }
      }
    } else {
      if (webStep == step) {
        className = ' tuto-full-opacity';
      }
    }
    return className;
  }

  function renderIconClose() {
    const className = ['close-tuto'];
    className.push('close-tuto-step-' + step);
    return (
      <Icon
        icon="Plus"
        className={className.join(' ')}
        onClick={() => onClose()}
      />
    );
  }
  function renderCgrmModal() {
    return (
      <div style={{ height: '100%' }}>
        <div className={styles['medadom-modal-close-container']}>
          <button
            className={styles['medadom-modal-close-btn']}
            onClick={onCgrmClose}
          >
            <Icon
              icon="CloseIcon"
              size={20}
              color="#000"
              className={styles['medadom-modal-close-icon']}
            />
          </button>
        </div>
        <div className={styles['cgrm-modal-content-container']}>
          <Img src={cgrmIntroModalImg} className="affiliation-content-img" />
          <p>Cher adhérent,</p>
          <p style={{ fontWeight: 'bold' }}>
            Depuis le 1er janvier 2023 votre contrat est géré par notre filiale
            CGRM.{' '}
          </p>
          <p>
            Pour toute demande de remboursement ou devis antérieur au 1er
            janvier 2023 vous pouvez les déposer sur cet espace.
          </p>
          <p>
            Si votre demande est postérieure à cette date, vous pouvez vous
            rendre sur votre espace{' '}
            <a href="https://monespace.cgrm.fr/">https://monespace.cgrm.fr/</a>{' '}
            ou sur votre application mobile CGRM.{' '}
          </p>
          <p>
            Si vous n’avez pas encore de compte CGRM, pas de panique ! Il sera
            créé en quelques secondes en vous munissant de votre numéro de
            Sécurité sociale.{' '}
          </p>
          <p>A bientôt </p>
          <p>L’équipe SPVIE Assurances </p>
        </div>
      </div>
    );
  }
  function renderContentTuto() {
    const contentClassName = ['content-tuto'];
    if (window.innerWidth < 762) {
      if (
        step == 4 ||
        step == 5 ||
        step == 6 ||
        step == 7 ||
        step == 8 ||
        step == 9
      ) {
        contentClassName.push('medium-content-tuto');
      }
      // if (step == 9) {
      //   contentClassName.push('small-content-tuto');
      // }
    } else {
      if (step == 2 || step == 6 || step == 7 || step == 8 || step == 9) {
        contentClassName.push('medium-content-tuto');
      }
      if (step == 3 || step == 4 || step == 5) {
        contentClassName.push('small-content-tuto');
      }
    }
    contentClassName.push('step-' + step);
    return (
      <div className={contentClassName.join(' ')}>
        {renderIconClose()}
        {step === 1 && <Text text="Bienvenue !" className="welcome-tuto" />}
        {step === 1 && (
          <div>
            Retrouvez sur votre nouvel espace assuré toutes vos informations
            essentielles et et
            <span className="close-weight-web"> bien plus encore !</span>
            <p>Suivez-nous pour un tutoriel...</p>
          </div>
        )}
        {step === 2 && <div>Sur votre page d’accueil, vous trouverez :</div>}
        {step == 10 && (
          <p className="close-description">
            Nous vous souhaitons une bonne utilisation de votre{' '}
            <span className="close-weight">nouvel espace !</span>
          </p>
        )}
        {step != 1 && renderDescription()}
        <Button
          text={step === 1 ? 'Commencer' : step === 10 ? 'Terminer' : 'Suivant'}
          onClick={() => (step === 10 ? onClose() : setStep(step + 1))}
          className="btn-tuto"
        />
      </div>
    );
  }
  function onCgrmClose() {
    setCgrmModalShow(false);
    localStorage.setItem('showCgrmModal', null);
  }
  function onClose() {
    setShow(false);
    setStep(1);
  }
  function renderDescription() {
    let description = '';
    const mobileDescription = [
      '1. La possibilité de visualiser vos garanties',
      '2. Votre carte de tiers-payant digitale à télécharger ou partager par email',
      '3. Les deux derniers remboursements effectués',
      '4. Votre consommation en un coup d’oeil ',
      '4. La possibilité de faire une demande de remboursement',
      '5. La possibilité de nous transmettre des documents !',
      '6. Une barre de tâche qui vous permets d’accéder facilement à la page d’accueil, à votre profil, aux notifications et à l’espace contact',
      '7.  Votre identité, votre numéro d’adhérent ainsi que le menu avec toutes les catégories nécessaires ! '
    ];
    const webDescription = [
      '1. Votre carte de tiers-payant digitale à télécharger ou partager par email',
      '2. La possibilité de nous transmettre des documents !',
      '3. La possibilité de visualiser vos garanties',
      '4. Les deux derniers remboursements effectués',
      '5. La possibilité de faire une demande de remboursement',
      '6. Votre consommation en un coup d’oeil ',
      '7. Une barre de tâche qui vous permets d’accéder facilement à la page d’accueil, à votre profil, aux notifications et à l’espace contact',
      '8.  Votre identité, votre numéro d’adhérent ainsi que le menu avec toutes les catégories nécessaires ! '
      // '7.  Votre identité, votre numéro d’adhérent ainsi que le menu avec toutes les catégories nécessaires !'
    ];
    if (window.innerWidth < 762) {
      description = mobileDescription[step - 2];
    } else {
      description = webDescription[step - 2];
    }
    if (description != '') {
      return (
        <Text text={description} className="description-tuto" loader={false} />
      );
    }
    return null;
  }
   const REMBOURSEMENT_STATUT_ICON = {
    [REMBOURSEMENT_STATUT.EFFECTUE]: 'Valid',
    [REMBOURSEMENT_STATUT.EN_ATTENTE]: 'EnCours'
  };
   const renderRemboursement = (element, index) => {
    const statutRemboursement = getRemboursementStatut(element?.reglement);
    const soinsDate = element?.ligne?.[0]?.dateActe?.shortDate;
    return (
      <div
        key={String(index)}
        className={`${styles['repayment-row']} ${
          styles[`repayment-row-${statutRemboursement}`]
        }`}
      >
        <div className={styles['repayment-avatar']}>
          <Icon icon="Profile" size="18px" color="#8a8a8a" />
        </div>
        <div className={styles['repayment-row-content']}>
          <div className={styles['repayment-row-top']}>
            <Text
                type={'h5'}
              text={
                <>
                  <span className={styles['repayment-name']}>
                    {element?.ligne[0]?.ayantDroit}
                  </span>

                  <SoinsDateActe lines={element?.ligne} />
                </>
              }
              className={styles['repayment-row-top-text']}
            />
            <Text
                type={'h5'}
              text={`${element?.reglement?.totalRembCGRM} €`}
              className={styles['repayment-amount']}
            />
          </div>
          <BadgeStatut
            statut={statutRemboursement}
            variant="filled"
            icon={REMBOURSEMENT_STATUT_ICON[statutRemboursement]}
            text={BADGE_LABEL_BY_STATUT[statutRemboursement]}
          />
        </div>
      </div>
    );
  };
  const contractTemplate = () => {
    return (
      <div className="home-container template-scroll mb-61 pt-34">
        <Row style={{ height: '100%' }}>
          <Col
            lg={{ span: 6, order: 1 }}
            md={{ span: 12, order: 3 }}
            xs={{ span: 12, order: 3 }}
            className="home-remboursement-col-prev-temp-first"
          >
            <Link to="/documents/send">
              <div
                className={
                  'home-document-card-container-prev-temp' +
                  renderClassNameTuto(7, 3)
                }
              >
                <Text
                  text="Envoyer un document"
                  className="desc-home-prev-temp"
                />
              </div>
            </Link>
          </Col>
          <Col
            lg={{ span: 6, order: 2 }}
            md={{ span: 12, order: 1 }}
            xs={{ span: 12, order: 1 }}
            className="home-remboursement-col-prev-temp-second"
          >
            <Link to="/documents">
              <div
                className={
                  'home-contact-card-container-prev-temp' +
                  renderClassNameTuto(2, 4)
                }
              >
                <Text
                  text="Visualiser mes documents"
                  className="desc-home-prev-temp"
                />
              </div>
            </Link>
          </Col>
          <Col
            lg={{ span: 6, order: 3 }}
            md={{ span: 12, order: 2 }}
            xs={{ span: 12, order: 2 }}
            className="home-remboursement-col-prev-temp-third"
          >
            <div
              className={
                'home-profil-card-container' + renderClassNameTuto(5, 7)
              }
              onClick={() => props.ProfilMobileClicked()}
            >
              <div className="home-contact-title-prev-temp">
                <Text
                  text="Profil"
                  className="home-actuality-content-title-prev-temp"
                />
              </div>
              <div className="home-actuality-description-container-prev-temp">
                <Text
                  text={`Visualisez vos informations personnelles et bancaires`}
                  className="home-actuality-description"
                />
              </div>
              <div className="home-remboursement-button-container">
                <Button
                  text="Voir mon profil"
                  className="home-remboursement-button-prev-temp"
                  onClick={() => {
                    props.CheckProfil();
                  }}
                />
              </div>
            </div>
          </Col>
          <Col
            lg={{ span: 6, order: 4 }}
            md={{ span: 12, order: 4 }}
            xs={{ span: 12, order: 4 }}
            className="home-remboursement-col-prev-temp-forth"
          >
            <div
              className={'home-contact-card'}
              onClick={() => props.ContactMobileClicked()}
            >
              <div className="home-contact-title-prev-temp">
                <Text
                  text="Contactez-nous"
                  className="home-actuality-content-title-prev-temp"
                />
              </div>
              <div className="home-actuality-description-container-prev-temp">
                <Text
                  text={`Vous avez une question ? N'hesitez pas à nous contacter`}
                  className="home-actuality-description"
                />
              </div>
              <div className="home-remboursement-button-container">
                <Button
                  text="Contactez SPVIE assurances"
                  className="home-remboursement-button-prev-temp"
                  onClick={() => {
                    props.Contact();
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const closeMedadomModal = () => {
    setShowMedadomMododal(false);
    setTimeout(() => setMedadomModalStep(1), 500);
  };

  const renderMedadomModalContent = () => {
    return (
      <div style={{ height: '100%' }}>
        <div className={styles['medadom-modal-close-container']}>
          <button
            className={styles['medadom-modal-close-btn']}
            onClick={props.onCloseMedadomModal}
          >
            <Icon
              icon="CloseIcon"
              size={20}
              color="#000"
              className={styles['medadom-modal-close-icon']}
            />
          </button>
        </div>
        <div className={styles['medadom-modal-content-container']}>
          {props.medadomModalStep === 1 ? (
            <>
              <div className={styles['medadom-modal-title']}>
                Vous recherchez un professionnel de santé :
              </div>
              <button
                className={styles['medadom-modal-btn']}
                onClick={props.onNextStepMedadomModal}
              >
                Proche de vous
              </button>
              <button
                className={styles['medadom-modal-btn']}
                onClick={props.onPressMedadomTeleconsultation}
              >
                En téléconsultation
              </button>
            </>
          ) : (
            <>
              <div className={styles['medadom-modal-title']}>
                Vous souhaitez :
              </div>
              <button
                className={styles['medadom-modal-btn']}
                onClick={props.onPressMedadomUseHealthService}
              >
                Utiliser votre réseau de soins
              </button>
              <button
                className={styles['medadom-modal-btn']}
                onClick={props.onPressGeolocateAroundMe}
              >
                Géolocaliser un praticien
              </button>
            </>
          )}
        </div>
      </div>
    );
  };

  if (!props.contractFamily.includes('SANTE')) {
    return contractTemplate();
  } else {
    return (
      <div
        className={`home-container template-scroll mb-36 pt-34 ${styles['home-container']}`}
      >
        <ModalRating
          show={rating.show}
          onHide={props.ratingModalHide}
          size={window.innerWidth < 768 ? 'small' : 'meduim'}
          contentClassName="rating-content"
          containerIconClassName="rating-icon-container"
          garanteeValue={props.garanteeValue}
          ratingChange={props.ratingChange}
          manegementValue={props.manegementValue}
          manegementComentary={props.manegementComentary}
          manegementSendClicked={props.manegementSendClicked}
          garanteeSendClicked={props.garanteeSendClicked}
          garanteeComentary={props.garanteeComentary}
          hide={props.ratingModalHide}
          hideGaranteeComentary={props.hideGaranteeComentary}
          hideManegementComentary={props.hideManegementComentary}
          ratingGaranteeChange={props.ratingGaranteeChange}
          ratingManegementChange={props.ratingManegementChange}
          onHideWithReset={props.ratingModalHide}
        />
        <ModalConfirmRating
          contentClassName="rating-content"
          containerIconClassName="rating-icon-container"
          show={props.modalSentShow}
          onHide={props.ratingModalHide}
          onHideWithReset={props.ratingModalHide}
          size={window.innerWidth < 768 ? 'small' : 'meduim'}
        />
        <Modal
          show={cgrmModalShow}
          onHide={() => setShow(false)}
          dialogClassName={styles['medadom-modal-container']}
          contentClassName={styles['cgrm-modal']}
          showIconClose={false}
          size={'larg'}
        >
          {renderCgrmModal()}
        </Modal>
        <Modal
          show={show}
          onHide={() => setShow(false)}
          contentClassName="modal-tuto"
          showIconClose={false}
        >
          {renderContentTuto()}
        </Modal>

        <Modal
          show={props.medadomModalOpen}
          onHide={props.onCloseMedadomModal}
          dialogClassName={styles['medadom-modal-container']}
          contentClassName={styles['medadom-modal']}
          showIconClose={false}
        >
          {renderMedadomModalContent()}
        </Modal>

        <div style={{ gridArea: 'additional-services' }}>
          <Row>
            <Col xs={12}>
              <h1
                className={`${styles['category-title']} ${styles['hidden-on-mobile']}`}
              >
                Nos services supplémentaires
              </h1>
            </Col>
          </Row>
          <Row className={styles['container-row']}>
            <Col xs={12}>
              <div
                className={styles['medadom-btn']}
                onClick={props.onOpenMedadomModal}
              >
                <div>
                  <div className={styles['medadom-btn-title']}>
                    Trouvez un professionnel de santé près de chez vous ou en
                    téléconsultation ; privilégiez votre réseau de soins pour
                    être mieux remboursé !
                  </div>
                  <div className={styles['medadom-btn-more-text']}>
                    En savoir plus
                  </div>
                </div>
                <img
                  src={NewHomeMedadomImage}
                  className={styles['medadom-btn-img']}
                />
              </div>
            </Col>
          </Row>
        </div>

        <div style={{ gridArea: 'shortcuts' }}>
          <Row>
            <Col xs={12}>
              <h1
                className={`${styles['category-title']} ${styles['hidden-on-mobile']}`}
              >
                Accès rapide
              </h1>
            </Col>
          </Row>
          <Row className={styles['container-row']}>
            <Col xs={12} style={{ padding: 0 }}>
              <div
                ref={shortcutCarouselRef}
                className={styles['carousel-container']}
                onScroll={handleScroll}
              >
                {SHORTCUTS_ELEMENTS.map((item, idx) => (
                  <ShortcutButton
                    key={idx}
                    text={item.text}
                    image={item.img}
                    onClick={item.onClick}
                    optClass={item.optClass}
                    disableArrow={idx === SHORTCUTS_ELEMENTS.length - 1}
                  />
                ))}
              </div>
              <div className={styles['carousel-dots-container']}>
                {SHORTCUTS_ELEMENTS.map((item, idx) => (
                  <div
                    key={idx}
                    className={styles['carousel-dots']}
                    style={{
                      backgroundColor: carouselPage === idx ? '#fff' : '#d9d9d9'
                    }}
                  />
                ))}
              </div>
            </Col>
          </Row>
        </div>

        <div style={{ gridArea: 'repayments' }}>
          <Row>
            <Col xs={12}>
              <h1 className={`${styles['category-title']}`}>
                Vos derniers remboursements
              </h1>
            </Col>
          </Row>
          <Row className={styles['container-row']}>
            <Col xs={12}>
              <div className={styles['repayment-card']}>
                <div className={styles['repayment-card-header']}>
                  <div className={styles['repayment-card-header-left']}>
                    <span className={styles['repayment-card-header-bar']} />
                    <Text
                      text="Suivi de vos dossiers"
                      className={styles['repayment-card-header-title']}
                    />
                  </div>
                  <div
                    className={styles['repayment-card-header-link']}
                    onClick={props.remboursementClicked}
                  >
                    <Text
                      text="Tout l'historique"
                      className={styles['repayment-card-header-link-text']}
                    />
                    <Icon icon="arrow-right" size="12px" color="#e50050" />
                  </div>
                </div>
                <div className={styles['repayment-card-body']}>
                  {props.remboursementLoadingDone &&
                  props.remboursement?.length === 0 ? (
                    <Text
                      text="Aucun remboursement à afficher"
                      type="h8"
                      style={{ color: '#000', textAlign: 'center' }}
                      className={styles['repayment-empty']}
                    />
                  ) : null}
                  {props.remboursement.map((el, i) => renderRemboursement(el, i))}
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <div style={{ gridArea: 'consomation' }}>
          <Row>
            <Col xs={12}>
              <h1 className={`${styles['category-title']}`}>
                Votre consommation {new Date().getFullYear()}
              </h1>
            </Col>
          </Row>
          <Row className={styles['container-row']}>
            <Col xs={12}>
              <Link
                to={{
                  pathname: '/consommation',
                  state: {
                    status: 'consomation',
                    beginDate: twoYearsAgoDate,
                    endDate: new Date()
                  }
                }}
              >
                <div
                  className={`home-consomation-card-container ${styles['home-consomation']}`}
                >
                  <div className="home-chart-container">
                    <div
                      className={`chart-legends-container ${styles['home-consomation-legend-container']}`}
                    >
                      {props.seriesVisionGlobal.map((element, index) => {
                        return (
                          <ChartLegendMolecule
                            key={String(index)}
                            legend={element.legend}
                            color={element.color}
                            classNameContainer="home-legend-container"
                            classNameText={`home-legend-text ${styles['home-consomation-legend-text']}`}
                          />
                        );
                      })}
                    </div>
                    <div className="home-chart-content">
                      <Chart
                        options={getOptionChart(
                          props.seriesVisionGlobal.map(
                            (element) => element.color
                          )
                        )}
                        series={props.seriesVisionGlobal.map(
                          (element) => element.data
                        )}
                        type="donut"
                        height={windowHeight > 900 ? '200px' : '150px'}
                        width={windowWidth > 600 ? '200px' : '100px'}
                        // width='150px'
                      />
                    </div>
                  </div>
                </div>
              </Link>
            </Col>
          </Row>
        </div>
      </div>
    );

    return (
      <div className="home-container template-scroll mb-61 pt-34">
        <ModalRating
          show={rating.show}
          onHide={props.ratingModalHide}
          size={window.innerWidth < 768 ? 'small' : 'meduim'}
          contentClassName="rating-content"
          containerIconClassName="rating-icon-container"
          garanteeValue={props.garanteeValue}
          ratingChange={props.ratingChange}
          manegementValue={props.manegementValue}
          manegementComentary={props.manegementComentary}
          manegementSendClicked={props.manegementSendClicked}
          garanteeSendClicked={props.garanteeSendClicked}
          garanteeComentary={props.garanteeComentary}
          hide={props.ratingModalHide}
          hideGaranteeComentary={props.hideGaranteeComentary}
          hideManegementComentary={props.hideManegementComentary}
          ratingGaranteeChange={props.ratingGaranteeChange}
          ratingManegementChange={props.ratingManegementChange}
          onHideWithReset={props.ratingModalHide}
        />
        <ModalConfirmRating
          contentClassName="rating-content"
          containerIconClassName="rating-icon-container"
          show={props.modalSentShow}
          onHide={props.ratingModalHide}
          onHideWithReset={props.ratingModalHide}
          size={window.innerWidth < 768 ? 'small' : 'meduim'}
        />
        <Modal
          show={show}
          onHide={() => setShow(false)}
          contentClassName="modal-tuto"
          showIconClose={false}
        >
          {renderContentTuto()}
        </Modal>

        <Row style={{ height: '100%' }}>
          <Col
            lg={{ span: 4, order: 1 }}
            md={{ span: 6, order: 2 }}
            xs={{ span: 6, order: 2 }}
            className="home-remboursement-col"
          >
            <Link to="/cartetp">
              <div
                className={
                  'home-carteTp-card-container' + renderClassNameTuto(3, 2)
                }
              >
                <Text text="Ma carte de tiers-payant" />
              </div>
            </Link>
          </Col>
          <Col
            lg={{ span: 4, order: 2 }}
            md={{ span: 6, order: 6 }}
            xs={{ span: 6, order: 6 }}
            className="home-remboursement-col"
          >
            <Link to="/documents/send">
              <div
                className={
                  'home-document-card-container' + renderClassNameTuto(7, 3)
                }
              >
                <Text text="Envoyer un document" />
              </div>
            </Link>
          </Col>
          <Col
            lg={{ span: 4, order: 3 }}
            md={{ span: 6, order: 1 }}
            xs={{ span: 6, order: 1 }}
            className="home-remboursement-col home-remboursement-cantact-card-container"
          >
            <Link to="/Garanties">
              <div
                className={
                  'home-contact-card-container' + renderClassNameTuto(2, 4)
                }
              >
                <Text text="Visualiser mes" />
                <Text text="garanties" />
              </div>
            </Link>
          </Col>
          <Col
            lg={{ span: 12, order: 4 }}
            md={{ span: 12, order: 3 }}
            xs={{ span: 12, order: 3 }}
            className="home-remboursement-col"
          >
            <div
              className={
                'home-remboursement-card-container' + renderClassNameTuto(4, 5)
              }
              onClick={() => props.remboursementMobileClicked()}
            >
              <>
                <Text
                  text="Derniers remboursements"
                  className="home-remboursement-title"
                />
                {props.remboursementLoadingDone &&
                props.remboursement?.length === 0 ? (
                  <Text
                    text="Aucun remboursement à afficher"
                    type="h8"
                    style={{ color: '#fff', textAlign: 'center' }}
                  />
                ) : null}
                {props.remboursement.map((el, i) => renderRemboursement(el, i))}
                <div className="home-remboursement-button-container">
                  <Button
                    text="Voir tous mes remboursements"
                    className="home-remboursement-button"
                    onClick={props.remboursementClicked}
                  />
                </div>
              </>
            </div>
          </Col>
          <Col
            lg={{ span: 6, order: 5 }}
            md={{ span: 6, order: 5 }}
            xs={{ span: 6, order: 5 }}
            className="home-remboursement-col home-remboursement-cantact-card-container"
          >
            <div
              className={
                'home-actuality-card-container' + renderClassNameTuto(6, 6)
              }
              onClick={() => props.SendBillMobileClicked()}
            >
              <Text
                text="Demander un remboursement"
                className="home-actuality-content-title"
              />
              <div className="home-actuality-description-container">
                <Text
                  text={
                    <>
                      Vous souhaitez vous faire rembourser des frais de santé ?{' '}
                      <span className="home-actuality-description-bold close-weight">
                        Envoyez nous votre facture !
                      </span>
                    </>
                  }
                  className="home-actuality-description"
                />
              </div>
              <div className="home-remboursement-button-container">
                <Button
                  text="Envoyer votre facture"
                  className="home-remboursement-button"
                  onClick={() => {
                    props.sendBill();
                  }}
                />
              </div>
            </div>
          </Col>
          <Col
            lg={{ span: 6, order: 6 }}
            md={{ span: 12, order: 4 }}
            xs={{ span: 12, order: 4 }}
            className="home-remboursement-col"
          >
            <Link
              to={{
                pathname: '/remboursement',
                state: { status: 'consumption' }
              }}
            >
              <div
                className={
                  'home-consomation-card-container' + renderClassNameTuto(5, 7)
                }
              >
                <Text
                  text={`Consommation ${new Date().getFullYear()}`}
                  className="home-consomation-title"
                />
                <div className="home-chart-container">
                  <div className="chart-legends-container">
                    {props.seriesVisionGlobal.map((element, index) => {
                      return (
                        <ChartLegendMolecule
                          key={String(index)}
                          legend={element.legend}
                          color={element.color}
                          classNameContainer="home-legend-container"
                          classNameText="home-legend-text"
                        />
                      );
                    })}
                  </div>
                  <div className="home-chart-content">
                    <Chart
                      options={getOptionChart(
                        props.seriesVisionGlobal.map((element) => element.color)
                      )}
                      series={props.seriesVisionGlobal.map(
                        (element) => element.data
                      )}
                      type="donut"
                      height={windowHeight > 900 ? '230px' : '150px'}
                      width="200px"
                    />
                  </div>
                </div>
              </div>
            </Link>
          </Col>
        </Row>
        {/* <div
          className={'feed-back-container ' + renderClassNameTuto(0, 8)}
          onClick={props.ratingModalShowClicked}
        >
          Votre avis nous intéresse
        </div> */}
      </div>
    );
  }
}

export default TemplateHome;
